import { useTranslation } from 'react-i18next'
import { Checkbox, Radio } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage'
import { faCode } from '@fortawesome/pro-solid-svg-icons/faCode'
import { faVideo } from '@fortawesome/pro-solid-svg-icons/faVideo'
import { RadioChangeEvent } from 'antd/lib/radio'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { MultimediaContentType } from 'enum'
import { IQuestionBankQuestion } from 'interfaces/questionBank'
import { Wrapper, Container } from './styled'
import Image from './image'
import Video from './video'
import Code from './code'

interface IProps {
  question: IQuestionBankQuestion
  setQuestion: (value: IQuestionBankQuestion) => void
}

const MultimediaContent = ({ question, setQuestion }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix =
    'administration.blocks.type.questionBankV2.sections.manageQuestion.multimediaContent'

  const handleMultimediaContentType = (e: RadioChangeEvent) => {
    const type = e.target.value
    setQuestion({
      ...question,
      multimediaContent: {
        type: type,
        value: '',
      },
    })
  }

  const handleAddMultimediaContent = (e: CheckboxChangeEvent) => {
    const checked = e.target.checked
    if (!checked) return setQuestion({ ...question, multimediaContent: null })

    setQuestion({
      ...question,
      multimediaContent: {
        type: MultimediaContentType.image,
        value: '',
      },
    })
  }

  const multimediaContent = question.multimediaContent

  const onChangeMultimediaContent = (value: string) => {
    if (!multimediaContent) return

    setQuestion({
      ...question,
      multimediaContent: { type: multimediaContent.type, value },
    })
  }

  return (
    <Wrapper>
      <Checkbox
        checked={!!question.multimediaContent}
        onChange={(e) => handleAddMultimediaContent(e)}
      >
        {t(`${translationPrefix}.add`)}
      </Checkbox>
      {multimediaContent && (
        <Container>
          <Radio.Group
            value={multimediaContent.type}
            onChange={(e) => handleMultimediaContentType(e)}
          >
            <Radio.Button value={MultimediaContentType.image}>
              <FontAwesomeIcon icon={faImage} />
              {t(`${translationPrefix}.types.image.title`)}
            </Radio.Button>
            <Radio.Button value={MultimediaContentType.video}>
              <FontAwesomeIcon icon={faVideo} />
              {t(`${translationPrefix}.types.video.title`)}
            </Radio.Button>
            <Radio.Button value={MultimediaContentType.code}>
              <FontAwesomeIcon icon={faCode} />
              {t(`${translationPrefix}.types.code.title`)}
            </Radio.Button>
          </Radio.Group>
          {multimediaContent.type === MultimediaContentType.image && (
            <Image
              value={multimediaContent.value}
              onChange={onChangeMultimediaContent}
            />
          )}
          {multimediaContent.type === MultimediaContentType.video && (
            <Video
              value={multimediaContent.value}
              onChange={onChangeMultimediaContent}
            />
          )}
          {multimediaContent.type === MultimediaContentType.code && (
            <Code
              value={multimediaContent.value}
              onChange={onChangeMultimediaContent}
            />
          )}
        </Container>
      )}
    </Wrapper>
  )
}

export default MultimediaContent
